import RepaymentScheduleTab from './RepaymentScheduleTab.vue';

export default RepaymentScheduleTab;
